import SvgIcon from 'material-ui/SvgIcon';
import React from 'react';
/**
 * Created by max on 30/08/2017.
 */
const NonInventory = props => (
  <SvgIcon {...props}>
    <defs>
      <path d="M12.75,19.9079776 L20.61,16.8849007 L20.61,6.77404711 L12.75,4.05327787 L12.75,19.9079776 Z M11.25,19.9079776 L11.25,4.05327787 L3.39,6.77404711 L3.39,16.8849007 L11.25,19.9079776 Z M22.11,6.24 L22.11,17.4 C22.11,17.7103288 21.9188783,17.9886077 21.6292343,18.1000092 L12.2692343,21.7000092 C12.0959329,21.7666636 11.9040671,21.7666636 11.7307657,21.7000092 L2.37076569,18.1000092 C2.08112166,17.9886077 1.89,17.7103288 1.89,17.4 L1.89,6.24 C1.89,5.92034715 2.09259959,5.63582227 2.39466708,5.53126044 L11.7546671,2.29126044 C11.9135962,2.23624652 12.0864038,2.23624652 12.2453329,2.29126044 L21.6053329,5.53126044 C21.9074004,5.63582227 22.11,5.92034715 22.11,6.24 Z" id="noninventory-path-1" />
    </defs>
    <g id="Icon/Product/NonInventory" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <mask id="noninventory-mask-2" fill="white">
          <use xlinkHref="#noninventory-path-1" />
        </mask>
      <use fill={props.color} fillRule="nonzero" xlinkHref="#noninventory-path-1" />
      <g mask="url(#noninventory-mask-2)" fill={props.color}>
          <rect id="Rectangle" x="0" y="0" width="24" height="24" />
        </g>
    </g>
  </SvgIcon>
);

export default NonInventory;



// WEBPACK FOOTER //
// ./src/icons/types/NonInventory.jsx